import { Component, EventBus } from '../core/smpl-components.js'
import { Events } from '../core/events.js'

// -----------------------------------------------------------------------------
// Body — example component.
//
// Demonstrates the component pattern (register → prepare → mount → unmount) and
// listening to a cross-cutting signal via the EventBus. It is the single
// component wired in the boilerplate registry; use it as a reference for new
// components. Selector: `body` (see setup/components.js).
// -----------------------------------------------------------------------------
export default class extends Component {
	prepare() {
		this.bndOnContentReplace = this.onContentReplace.bind(this)
		EventBus.on(Events.SWUP_CONTENT_REPLACE, this.bndOnContentReplace)
	}

	mount() {}

	unmount() {
		EventBus.off(Events.SWUP_CONTENT_REPLACE, this.bndOnContentReplace)
	}

	// Re-run per-page setup after a Swup navigation swaps the DOM.
	onContentReplace() {}
}
